import { useDispatch, useSelector } from 'react-redux';
import { getCurrenciesPI, getIntegrationKeys, setShopifyTestMode } from './actions';
import { PaymentIntegrationSelectors } from './selectors';

export const usePaymentIntegration = () => {
  const dispatch = useDispatch();

  return {
    loading: useSelector(PaymentIntegrationSelectors.getLoading),
    error: useSelector(PaymentIntegrationSelectors.getError),
    errorInfo: useSelector(PaymentIntegrationSelectors.getErrorInfo),
    apiKey: useSelector(PaymentIntegrationSelectors.getApiKey),
    currencies: useSelector(PaymentIntegrationSelectors.getCurrencies),
    shopifyIntegration: useSelector(PaymentIntegrationSelectors.getShopifyIntegration),
    getIntegrationKeys: () => dispatch(getIntegrationKeys()),
    getCurrenciesPI: (country: string) => dispatch(getCurrenciesPI(country)),
    setShopifyTestMode: (testMode: boolean) => dispatch(setShopifyTestMode(testMode)),
  };
};
